module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon_reserve_form-42b88eedcbb2df24d2484728d86053a4.png";